import { pathToUrl } from "utils/url";

import { PATHS } from "./constants";

export function getCreatePath(tabId = PATHS.createDefaultTab, initialAppId) {
  let path = pathToUrl(PATHS.create, { tabId });
  if (initialAppId) {
    path += `?initialAppId=${encodeURIComponent(initialAppId)}`;
  }
  return path;
}

export function getDetailsPath(id, tabId = PATHS.detailsDefaultTab) {
  return pathToUrl(PATHS.details, {
    id: encodeURIComponent(id),
    tabId,
  });
}

export function getEditPath(id, tabId = PATHS.editDefaultTab) {
  return pathToUrl(PATHS.edit, { id, tabId });
}
